module.exports = {
  THEME: 'nuxt-color-mode',
  COOKIE_CONSENT: 'ecosiaCookieConsent',
  EXTENSION_ACTIVE: 'ecosiaExtensionActive',
  PERSONAL_COUNTER_OVERLAY_DISMISSED: 'personalCounterOverlayDismissed',
  PERSONAL_COUNTER_TOOLTIP_SEARCH: 'personalCounterTooltipSearch',
  PERSONAL_COUNTER_TOOLTIP_TREE: 'personalCounterTooltipTree',
};
